import React, { Component } from 'react';
import {Pagination} from "react-bootstrap";
import Container from '../../components/Container';
import Heading from '../../components/Heading';
import Form from './components/Form';
import Table from './components/Table';
import API from '../../services/API';
import { PAGE_LIMIT } from "./config";
import { handleFieldChange } from "../../Utils";
import Switch from "react-toggle-switch";
import Graph from "./components/Graph";

class BidderFillRate extends Component {
    constructor() {
        super();

        this.state = {
            sources: [],
            affids: [],
            params: [],
            paramsObj: {},
            report: [],
            graph: [],
            type: 'hourly',
            sortParam: null,
            sortOrder: 1,
            pagesTotal: 0,
            activePage: 1,
            isLoading: false
        };

        this.handleFieldChange = handleFieldChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleSort = this.handleSort.bind(this);
        this.handlePageSelect = this.handlePageSelect.bind(this);
        this.handleTypeChange = this.handleTypeChange.bind(this);
    }

    componentDidMount() {
        Promise.all([
            API.BidderSources.getAvailableSourcesObj(),
            API.BidderFillRate.getAffids(),
        ])
            .then(([ sources, { affids } ]) => this.setState({ sources, affids }));

        this.setState({ isLoading: true });

        API.BidderFillRate.getGraph(this.state.type, { 'day': new Date().toISOString().split('T')[0] })
            .then(({ graph }) => this.setState({ graph, isLoading: false }));
    }

    componentWillUpdate(nextProps, nextState) {
        const { report, sortParam, sortOrder } = nextState;

        if(this.state.sortParam != sortParam || this.state.sortOrder != sortOrder) {
            this.sortReport(report, sortParam, sortOrder);

            this.setState({ report, activePage: 1 });
        }
    }

    sortReport(report, sortParam, sortOrder) {
        const paramIndex = this.state.paramsObj[sortParam];
        report.sort((objA, objB) => {
            let valueA = objA[paramIndex] ? objA[paramIndex] : 0;
            let valueB = objB[paramIndex] ? objB[paramIndex] : 0;

            if(sortParam === 'affid') {
                valueA = this.state.affids[valueA];
                valueB = this.state.affids[valueB];
            }



            if(valueA > valueB) return 1 * sortOrder;
            else if(valueA < valueB) return -1 * sortOrder;

            return 0;
        });
    }

    handleSubmit(filters) {
        this.setState({ isLoading: true });

        this.loadReport(filters);
    }

    loadReport(filters) {
        Promise.all([
            API.BidderFillRate.get(this.state.type, filters),
            API.BidderFillRate.getGraph(this.state.type, filters)
        ])
            .then(([ { params, report }, { graph } ]) => {
                const pagesTotal = Math.ceil(report.length / PAGE_LIMIT);
                const paramsObj = params.reduce((obj, param, index) => {
                    obj[param] = index;

                    return obj;
                }, {});
                const newState = { params, paramsObj, report, activePage: 1, pagesTotal, graph, isLoading: false };

                this.setState(newState)
            });
    }

    handleSort(param) {
        const { sortParam, sortOrder } = this.state;

        if(sortParam === null) this.setState({ sortParam: param });
        else if(param === sortParam) this.setState({ sortOrder: sortOrder * -1 });
        else this.setState({ sortParam: param, sortOrder: 1 });
    }

    handlePageSelect(activePage) {
        this.setState({ activePage });
    }

    handleTypeChange() {
        this.setState(prevState =>
            ({ type: prevState.type === 'hourly' ? 'daily' : 'hourly' }));
    }

    getGraph() {
        const { graph } = this.state;

        if(!graph.length) return;

        return <Graph data={graph} />;
    }

    getTable() {
        let { params, paramsObj, report, sources, affids, activePage } = this.state;

        if(report.length) {
            const pageStart = ( activePage - 1 ) * PAGE_LIMIT;
            const pageEnd = activePage * PAGE_LIMIT;
            report = report.slice(pageStart, pageEnd);

            return <Table params={params} paramsObj={paramsObj} report={report} sources={sources} affids={affids} onSortChange={this.handleSort}/>;
        }

        return <p>No Data</p>
    }

    render() {
        const { isLoading, sources, affids } = this.state;

        return (
            <Container loading={isLoading}>
                <Heading title="Bidder Network Performance Hourly V2"/>
                <div style={{ marginBottom: '15px' }}>
                    <span>Hourly </span>
                    <Switch onClick={this.handleTypeChange} on={this.state.type === 'daily'} />
                    <span> Daily</span>
                </div>
                <Form onSubmit={this.handleSubmit} sources={sources} affids={affids} type={this.state.type}/>

                {this.getGraph()}
                {this.getTable()}

                <Pagination
                    items={this.state.pagesTotal}
                    maxButtons={20}
                    onSelect={this.handlePageSelect}
                    activePage={this.state.activePage}
                />
            </Container>
        );
    }
}

export default BidderFillRate;



// WEBPACK FOOTER //
// ./src/scenes/BidderFillRate/index.js